export function isRnDError(err: any): err is RndError {
    return err && err._type === 'RndError'
}

export class RndError extends Error {
    public readonly _type = 'RndError'

    constructor(public readonly code: string, message?: string) {
        super(message || code)
        this.code = code
    }
}
